// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VGcB","toggleWrap":"styles_toggleWrap__1yt__","content":"styles_content__2yXKa","selectAreaCode":"styles_selectAreaCode__1_eun"};